export { Label } from "./label.vue";
